import { render, staticRenderFns } from "./AddProForma.vue?vue&type=template&id=b7b344b4&scoped=true&"
import script from "./AddProForma.vue?vue&type=script&lang=js&"
export * from "./AddProForma.vue?vue&type=script&lang=js&"
import style0 from "./AddProForma.vue?vue&type=style&index=0&id=b7b344b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b344b4",
  null
  
)

export default component.exports